let defaultWidth = 1024;
export function  detectResize(callbackFunction : ()=> void) {
    
    if(window.innerWidth >= defaultWidth){
        
        if(typeof(callbackFunction) === "function"){
            callbackFunction();
        }
    }
    
}

export function ScrollToTop(){
    window.scrollTo({
        top: 0,
        behavior: "auto"
    });
}